/* global moment CryptoJS */
/* eslint max-len: ["error", { "code": 125, "tabWidth": 4 }] */
/* eslint-disable no-console */
/* eslint-disable node/no-unsupported-features */
import {env} from '../constants/env';

export class Utils {
    static init(module) {
        console.log(module + ': INIT');
    }
    static log(module, message) {
        console.log(module + ': ' + message);
    }

    static err(module, message) {
        console.log(module + ': ERROR!!: ' + message);
    }

    static logobj(module, message, event) {
        console.log(module + ': ' + message, event);
    }

    static errobj(module, message, event) {
        console.log(module + ': ERROR!!: ' + message, event);
    }

    static sendToLocation(urlLoc) {
        window.history.pushState({}, null, urlLoc);
        window.dispatchEvent(new CustomEvent('location-changed'));
    }

    static isSmallscreen() {
        return window.innerWidth <= 640;
    }

    // noinspection JSUnusedGlobalSymbols
    static apiUrl() {
        return env.apiUrl;
    }

    // noinspection JSUnusedGlobalSymbols
    static apiUrlWP() {
        return 'https://api-stage.webdevotion.net/index.php';
    }

    static isEmpty(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    static auth(xhr, crypt) {
        // noinspection ES6ModulesDependencies, JSUnresolvedFunction
        let now = moment();
        xhr.setRequestHeader('Date-Punter', now.toISOString());
        // eslint-disable-next-line
        let hash = CryptoJS.HmacSHA512(now.toISOString()+'Reviews.2018'+crypt, 'Punterbook.2017');
        xhr.setRequestHeader('Auth-Punter', hash.toString(CryptoJS.enc.Base64));
    }

    // noinspection JSUnusedGlobalSymbols
    static encode(toEncode) {
        if (toEncode !== undefined) {
            return encodeURI(toEncode.replace(/\s/g, '+')).toLowerCase();
        } else {
            return undefined;
        }
    }

    // noinspection JSUnusedGlobalSymbols
    static splitUrl(urlstring, number) {
        if (urlstring === undefined) {
            return true;
        }

        let arrayPath = urlstring.split('/');
        let howMany = 0;

        arrayPath.forEach((element) => {
            if (element !== '') {
                howMany++;
            }
        });

        return howMany < number;
    }

    // noinspection JSUnusedGlobalSymbols
    static safeJSONParse(data) {
        let returnData;
        try {
            returnData = JSON.parse(data);
        } catch (e) {
            returnData = undefined;
        }
        return returnData;
    }

    // noinspection JSUnusedGlobalSymbols
    static dateHedline(myDate) {
        let now = moment();
        let datew = moment(myDate);
        if (now.diff(datew, 'minutes') <= 60) {
            let diff = now.diff(datew, 'minutes');
            if (diff === 1) {
                datew = diff + this.locale.minuteago;
            } else {
                datew = diff + this.locale.minutesago;
            }
        } else if (datew.isSame(now, 'day')) {
            let diff = now.diff(datew, 'hours');
            if (diff === 1) {
                datew = diff + this.locale.hourago;
            } else {
                datew = diff + this.locale.hoursago;
            }
        } else if (datew.isSame(now, 'week')) {
            datew = datew.format('dddd');
        } else if (datew.isSame(now, 'year')) {
            datew = datew.format('D MMMM');
        } else {
            datew = datew.format('D MMMM YYYY');
        }
        return datew;
    }

    // noinspection JSUnusedGlobalSymbols
    static getBrowserLanguage() {
        let browserLanguage;
        if (typeof navigator !== 'undefined' && typeof navigator.language !== 'undefined') {
            browserLanguage = navigator.language;
        }
        if (browserLanguage !== null) {
            const index = browserLanguage.indexOf('-');
            if (index !== -1) {
                browserLanguage = browserLanguage.substring(0, index);
            }
        }
        if (browserLanguage !== null && browserLanguage !== undefined) {
            return browserLanguage;
        } else {
            return 'it';
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Utils.js